<template>
  <service-view
    :pictures="pictures"
    :serviceTitle="serviceTitle"
    :plumbingActive="'active'"
    :serviceDescription="serviceDescription"
  />
</template>
<script>
import ServiceView from "./ServiceView";
export default {
  name: "plumbing",
  components: {
    ServiceView
  },
  data: () => ({
    pictures: [
      {
        name: "plumbing/IMG-20171007-WA0089.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "plumbing/IMG-20171007-WA0086.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      }
    ],
    serviceTitle: "Plumbing",
    serviceDescription:
      "Commercial and residential Plumbing, leak detection and depair, Sink repair, pipe fitting and supply."
  })
};
</script>
